import React, { useState, useEffect} from 'react';
import api from 'api';
import { Input, Button } from 'antd';
import { withRouter } from 'react-router-dom';
import './style.css';
import ErrorMessage from 'components/ErrorMessage';
import { css } from 'glamor';


const field = css({
    fontFamily: 'Raleway',
    width: '100%',
    backgroundColor: '#FBFBFC !important',
    '@media(min-width: 680px)': {
        marginBottom: '0px !important',
    }
});


const descriptionBox = css({
    resize: 'vertical',
    minHeight: '24px',

    '@media(min-width: 680px)': {
        minHeight: '24px !important',
        marginBottom: '0px !important',
    }

});

function PartsDataCatalog({history, ...props}) {

    const [products, setProducts] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {

        const part_list = products.split(/[\n,]+/).map(s => s.trim()).filter(Boolean);

        console.log(`submit parts ${part_list}`);

        let response = await api.rpc('createPartCatalog', {part_list});

        console.log(response);

        if (response.body.result.error) {
          setError(response.body.result.error || "Failed to generate PDF");
          return;
        }

        if (!response.body.result || !response.body.result.data_base64) {
          setError("Invalid response from server");
          return;
        }

        console.log(response);

        var base64 = response.body.result.data_base64;

        function base64ToBlob(base64, mime) {
          var byteChars = atob(base64);
          var byteNums = new Array(byteChars.length);
          for (var i = 0; i < byteChars.length; i++) byteNums[i] = byteChars.charCodeAt(i);

          return new Blob([new Uint8Array(byteNums)], { type: mime || 'application/octet-stream' });
        }

        var blob = base64ToBlob(base64, response.body.result.mime);
        var url = URL.createObjectURL(blob);
        window.open(url, '_blank');

    }

    // const setReleaseAll = async () => {

    //     let newQuantities = {};
    //     products.forEach(p => {
    //         newQuantities[p.product_id] = p.product_available;
    //     });

    //     setQuantities(newQuantities);
    // }


    return <div className='part'>
        <h1>Merge Parts PDFs</h1>
        <div style={{ marginBottom: 16 }}>
            <label>Part Numbers:</label>
            <Input.TextArea rows={4} 
                            onChange={e => setProducts(e.target.value)}
                            placeholder="Add list of parts..."
                            value={products} />
        </div>
        <ErrorMessage errors={error} />
        <Button style={{marginRight: '12px'}} onClick={e => { history.goBack() }}>Cancel</Button>
        <Button onClick={handleSubmit}>Generate</Button>
    </div>
}

export default withRouter(PartsDataCatalog);
